module.exports = __webpack_public_path__ + "img/main_story_slide4.71406d2a.jpg";